import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "./en";

const i18nProvider = polyglotI18nProvider((locale) => {
  switch (locale) {
    case "es":
      return import("./es").then((messages) => messages.default);
    case "sr":
      return import("./sr").then((messages) => messages.default);
    case "fr":
      return import("./fr").then((messages) => messages.default);
    default:
  }

  // Always fallback to english
  return englishMessages;
}, "en");

export default i18nProvider;
